// Do not change order.
const deliveryCourierList: string[] = ['EMS', 'ไปรษณีย์ลงทะเบียน', 'Kerry'];

const deliveryTermList: string[] = [
    'ภายใน 3 วันหลังสั่งซื้อ',
    'รอนำเข้าสินค้า 3-4 สัปดาห์',
];

export { deliveryCourierList, deliveryTermList };
